import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-foreground mb-8">Cookie Policy</h1>

          <div className="prose prose-sm max-w-none text-foreground space-y-6">
            <p className="text-muted-foreground">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">1. What Are Cookies?</h2>
              <p className="text-muted-foreground">
                Cookies are small text files that are placed on your device when you visit a website. They help websites remember your preferences and improve your browsing experience.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">2. How We Use Cookies</h2>
              <p className="text-muted-foreground mb-2">JobAspirant uses cookies for the following purposes:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Essential Cookies:</strong> Required for the website to function properly, including authentication and session management.</li>
                <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous usage data.</li>
                <li><strong>Preference Cookies:</strong> Remember your settings and preferences, such as your cookie consent choice.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">3. Types of Cookies We Use</h2>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Session Cookies:</strong> Temporary cookies that are deleted when you close your browser. Used for authentication and maintaining your session.</li>
                <li><strong>Persistent Cookies:</strong> Remain on your device for a set period or until you delete them. Used to remember your preferences and cookie consent.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">4. Third-Party Cookies</h2>
              <p className="text-muted-foreground">
                We may use third-party services that place cookies on your device. These services help us analyze website traffic, process payments, and provide authentication services. These third parties have their own privacy policies regarding cookie usage.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">5. Managing Cookies</h2>
              <p className="text-muted-foreground mb-2">You can control and manage cookies in several ways:</p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Most web browsers allow you to control cookies through their settings preferences.</li>
                <li>You can choose to block or delete cookies, though this may affect website functionality.</li>
                <li>You can withdraw your consent to non-essential cookies at any time by clearing your browser cookies or changing your browser settings.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">6. Cookie Consent</h2>
              <p className="text-muted-foreground">
                When you first visit our website, we will ask for your consent to use cookies. Your consent preference is stored locally on your device. You can change your cookie preferences at any time by clearing your browser's local storage or cookies.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-4">7. Contact Us</h2>
              <p className="text-muted-foreground">
                If you have questions about our use of cookies, please contact us at: <a href="mailto:contact@qubitlyventures.com" className="text-primary hover:underline">contact@qubitlyventures.com</a>
              </p>
              <p className="text-muted-foreground mt-2">
                <strong>Parent Company:</strong> Qubitly Ventures LLP, Delhi NCR, India
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePolicy;